// assets
import {
  AppstoreAddOutlined,
  ChromeOutlined,
  AntDesignOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  LoadingOutlined,
  SettingOutlined,
  TeamOutlined,
  BankOutlined,
  UserOutlined,
  ProjectOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  FontSizeOutlined,
  BgColorsOutlined,
  BarcodeOutlined,
  AntDesignOutlined,
  LoadingOutlined,
  AppstoreAddOutlined,
  SettingOutlined,
  TeamOutlined,
  BankOutlined,
  UserOutlined,
  ProjectOutlined
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'utilities',
  title: '',
  type: 'group',
  children: [
    {
      id: 'util-add-project',
      title: 'Clients',
      type: 'item',
      url: '/home/clients',
      icon: icons.ChromeOutlined,
      permission: 'clients.access'
    },
    {
      id: 'admin-collapse',
      title: 'Admin',
      type: 'collapse',
      icon: icons.SettingOutlined,
      permission: 'admin.access',
      children: [
        {
          id: 'admin-users',
          title: 'User Management',
          type: 'item',
          url: '/home/admin/users',
          icon: icons.TeamOutlined
        },
        {
          id: 'admin-companies',
          title: 'Company Management',
          type: 'item',
          url: '/home/admin/companies',
          icon: icons.BankOutlined
        }
      ]
    },
    {
      id: 'project-management-collapse',
      title: 'Project Assets',
      type: 'collapse',
      icon: icons.ProjectOutlined,
      permission: 'projectManagement.themes.access',
      children: [
        {
          id: 'project-management-themes',
          title: 'Themes',
          type: 'item',
          url: '/home/project-management/themes',
          icon: icons.BgColorsOutlined
        },
        {
          id: 'project-management-chart-templates',
          title: 'Templates',
          type: 'item',
          url: '/home/project-management/chart-templates',
          icon: icons.AppstoreAddOutlined,
          permission: 'projectManagement.templates.access'
        }
      ]
    },
    {
      id: 'client-portal-collapse',
      title: 'Client Portal',
      type: 'collapse',
      icon: icons.TeamOutlined,
      permission: 'client_portal.access',
      children: [
        {
          id: 'client-portal-users',
          title: 'My Team',
          type: 'item',
          url: '/home/client-admin/users',
          icon: icons.UserOutlined,
          permission: 'client_admin.users.create'
        },
        {
          id: 'client-portal-projects',
          title: 'My Projects',
          type: 'item',
          url: '/home/client-admin/projects',
          icon: icons.ProjectOutlined
        }
      ]
    }
  ]
};

export default utilities;